import { render, staticRenderFns } from "./BuyJpgLeaflet.vue?vue&type=template&id=21ae7f2f&scoped=true&"
import script from "./BuyJpgLeaflet.vue?vue&type=script&lang=js&"
export * from "./BuyJpgLeaflet.vue?vue&type=script&lang=js&"
import style0 from "./BuyJpgLeaflet.vue?vue&type=style&index=0&id=21ae7f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae7f2f",
  null
  
)

export default component.exports